import ShareIcon from '@moda/icons/share-20';
import { Clickable, useBreakpoint } from '@moda/om';
import React from 'react';
import { useProductShareV2 } from './useProductShareV2';

export const ProductShareV2Mobile = () => {
  const { handleCopy } = useProductShareV2();

  const { matches: isMobile } = useBreakpoint({ lt: 'sm' });

  if (!isMobile) return null;

  return (
    <Clickable className="ProductShareV2Mobile" aria-label="Share" onClick={handleCopy}>
      <ShareIcon />
    </Clickable>
  );
};
